import _defineProperty from "/app/store-locator/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import '../styles/antd.less';
import { Hydrate, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { GoogleTagManagerNoScript, GoogleTagManagerScript } from 'components/GoogleTagManager';
import { resources } from 'core/i18n/resources';
import { SettingsStoreContext, useSettingsStore } from 'core/modules/settings/settings.store';
import { Compose } from 'core/utils/store';
import i18n from 'i18next';
import Head from 'next/head';
import { useState } from 'react';
import { initReactI18next } from 'react-i18next';
import { config } from 'src/config';
import { template } from 'src/template';
import { LocalStorageRepository } from 'src/utils/local-storage.repository';
import { initGeolocation } from 'utils/geolocation';
i18n.use(initReactI18next).init({
  lng: 'fr',
  fallbackLng: ['fr', 'en'],
  resources: resources
}); // Geolocation

initGeolocation('fr', 'fr');
var localStorageRepository = new LocalStorageRepository();
export default function App(_ref) {
  var _template$fontLinks;

  var Component = _ref.Component,
      pageProps = _ref.pageProps;

  var _useState = useState(function () {
    return new QueryClient({
      defaultOptions: {
        queries: {
          staleTime: 4 * 24 * 60 * 1000,
          // 4 days
          cacheTime: Infinity
        }
      }
    });
  }),
      queryClient = _useState[0];

  var settings = useSettingsStore(config, localStorageRepository);
  return /*#__PURE__*/_jsxs(Compose, {
    components: [[SettingsStoreContext.Provider, {
      value: settings
    }]],
    children: [/*#__PURE__*/_jsxs(Head, {
      children: [/*#__PURE__*/_jsx("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
      }), /*#__PURE__*/_jsx("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com",
        crossOrigin: "true"
      }), /*#__PURE__*/_jsx("link", {
        href: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&display=swap",
        rel: "stylesheet"
      }), ((_template$fontLinks = template.fontLinks) !== null && _template$fontLinks !== void 0 ? _template$fontLinks : []).map(function (link) {
        return /*#__PURE__*/_jsx("link", {
          rel: "stylesheet",
          href: link
        }, link);
      }), /*#__PURE__*/_jsx("script", {
        defer: true,
        src: "https://maps.googleapis.com/maps/api/js?key=".concat(config.googleApiKey, "&libraries=places")
      }), /*#__PURE__*/_jsx("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
      }), /*#__PURE__*/_jsx(GoogleTagManagerScript, {
        id: config.googleTagManagerId
      })]
    }), settings.isInitialized && /*#__PURE__*/_jsx(QueryClientProvider, {
      client: queryClient,
      children: /*#__PURE__*/_jsx(Hydrate, {
        state: pageProps.dehydratedState,
        children: /*#__PURE__*/_jsx(Component, _objectSpread({}, pageProps))
      })
    }), /*#__PURE__*/_jsx(GoogleTagManagerNoScript, {
      id: config.googleTagManagerId
    })]
  });
}